import React, { useState } from 'react';
import Div from "@jumbo/shared/Div";
import ButtonStyled from 'app/components/ButtonStyled/ButtonStyled';
import { DOCUMENT } from 'app/utils/constants/endPoint';
import { DataGrid } from '@mui/x-data-grid';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import DatePicker from 'react-datepicker';
import { requestApi } from 'app/utils/RestApi';
import { isMobile } from 'react-device-detect';
import moment from 'moment';

const MicrositeDokument = () => {
	const [isLoading, setIsLoading] = useState(false);
	const [selectedMonth, setSelectedMonth] = useState(new Date(moment().subtract(1,
		'months')));
	const [docs, setDocs] = React.useState([])
	const [userData, setUserData] = React.useState(null)

	React.useEffect(() => {
		const userdata = localStorage.getItem('userdata');
		const dataLogin = JSON.parse(userdata);
		setUserData(dataLogin)

		document.querySelector("html").classList.add('overflow-hidden');
	}, []);

	React.useEffect(() => {
		if (userData) {
			fetchData();
		}
	}, [userData, selectedMonth]);

	const fetchData = async () => {
		const month = selectedMonth.getMonth() + 1
		const dateParam = selectedMonth.getFullYear() + '/' + month.toString().padStart(2, '0')
		
		try {
			const response = await requestApi(DOCUMENT.INDEX, {
				data: {
					date: dateParam,
					refCode: userData.userLoggedin.referrerCode
				}
			});

			const data = response.data.data || [];
			setDocs(data);
		} catch (error) {
			console.error(error);
		}
	};

	const handleMonthChange = (date) => {
		setSelectedMonth(date);
	};

	const columns = [
		{ field: 'id', headerName: 'No', minWidth: isMobile ? 100 : 40 },
		{ field: 'file_name', headerName: 'Nama File', minWidth: 250, flex: 1 },
		{ field: 'created_date', headerName: 'Tgl. Issued', minWidth: 150 },
		{
			field: 'action',
			headerName: 'Action',
			minWidth: 150,
			renderCell: (params) => {
				const handleDownload = async () => {
					const userdata = localStorage.getItem('userdata');
					const dataLogin = JSON.parse(userdata);
					const selectedDate = new Date(selectedMonth);
					const formattedDate = `${selectedDate.getFullYear()}/${(selectedDate.getMonth() + 1).toString().padStart(2, '0')}`;
					const refCode = dataLogin.userLoggedin.referrerCode;
					const filename = params.row.file_name;
					const fullPath = `${formattedDate}/${refCode}/${filename}`;
					setIsLoading(true);
					try {
						const { data, status } = await requestApi(DOCUMENT.DOCUMENT_DOWNLOAD, {
							params: {
								fullPath: fullPath
							}
						});

						if (status === 200) {
							const downloadLink = document.createElement("a");
							document.body.appendChild(downloadLink);
							downloadLink.href = data;
							downloadLink.target = '_blank';
							downloadLink.download = filename;
							downloadLink.style.display = "none";
							downloadLink.click();
							document.body.removeChild(downloadLink);
						}

						setIsLoading(false);
					} catch (error) {
						setIsLoading(false);
						console.error(error);
					}

				};

				return (
					<Div>
						<ButtonStyled
							onClick={handleDownload}
							btnText={"Download"}
							fullWidth={false}
							preset="round"
							textSize='12px'
							btnStyle={{ height: "30px" }}
						/>
					</Div>
				);
			},
		},
	]

	function CustomNoRowsOverlay() {
		return (
			<Div sx={{ textAlign: 'center' }}>Tidak ada data untuk ditampilkan</Div>
		)
	}

	return (
		<Div className='content-padding'>
			<Div className='white-container document-page'>
				<Div className='section-header'>Document</Div>
				<Div sx={{ overflowX: 'auto' }}>
					<Div sx={{ padding: '16px' }}>
						<DatePicker
							className='global-datepicker'
							placeholderText='Select month'
							showMonthYearPicker
							dateFormat="MM/yyyy"
							selected={selectedMonth}
							onChange={handleMonthChange}
							leftIcon={<CalendarMonthIcon sx={{ fontSize: 24 }} />}
						/>
					</Div>
					<div style={{ height: 400, width: '100%', padding: '0 24px' }}>
						<DataGrid
							key={docs.length}
							rows={docs.map((doc, index) => ({
								id: index + 1,
								file_name: doc.filename,
								created_date: doc.createdDate,
							}))}
							columns={columns}
							pageSize={10}
							style={{ width: '100%' }}
							slots={{
								noRowsOverlay: CustomNoRowsOverlay,
								noResultsOverlay: CustomNoRowsOverlay,
							}}
						/>
					</div>
				</Div>
			</Div>
		</Div>
	);
};

export default MicrositeDokument;